<script lang="ts">
	import type { ContextMenuItemState } from '../../types/ContextMenuStoreTypes';

	export let contextMenuState: ContextMenuItemState;
	export let isDisabled = false;
</script>

<button
	disabled={isDisabled}
	class:disabled={isDisabled}
	on:click
	class="text-left px-4 py-2 hover:bg-background dark:hover:bg-dark-200 
	 disabled:bg-background disabled:dark:bg-dark-300 disabled:text-darkgray disabled:dark:text-dark-500 {contextMenuState.danger ? "text-red dark:text-orange" : ""}"
>
	<p>{contextMenuState.title}</p>
</button>
